import { Config } from '@leverege/plugin'

export default {
  id : 'ps.action.OpenEventStartVideoUrl',
  matches : {
    client : 'LinearViewBlock'
  },
  layout : {
    group : [ 'Video', 'Start' ],
    groupIcons : [ 'fa fa-fw fa-video-camera' ]
  },
  appearance : ( { context } ) => ( {
    name : `Open (Offset: ${context.item.startData.videoOffset.toFixed( 2 )})`,
    icon : 'fa fa-fw fa-external-link'
  } ),
  handles : ( context ) => {
    const { item } = context
    
    return item?.startData != null
  },
  perform : ( { context } ) => {
    const { item } = context
    const videoBucketUrl = Config.get( 'LinearViewBlock', 'gcsVideoBucketUrl' )
    window.open( `${videoBucketUrl}/${item.startData.videoPath}`, '_blank' ).focus()
  }
}
